import api from "api/config";

export const GetInHouseGuestsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/in-house-guests/list",
    data,
  });

  return response;
};

export const GetGuestFlagsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/in-house-guests/flags",
    data,
  });

  return response;
};

export const SetGuestFlagAPI = async ({ hotelId, guestId, data }) => {
  const response = await api({
    method: "PATCH",
    url: `/api/v1/hotels/${hotelId}/guests/${guestId}/flag`,
    data,
  });

  return response;
};

export const GetReservationNotesAPI = async ({ hotelId, guestId, reservationId, query = {} }) => {
  const params = new URLSearchParams({
    limit: query.limit || 50,
    order: query.order || "desc",
    ...(query.before && { before: query.before }),
    ...(query.source && { source: query.source }),
    ...(query.category && { category: query.category }),
    ...(query.visibility && { visibility: query.visibility }),
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/hotels/${hotelId}/guests/${guestId}/reservations/${reservationId}/notes?${params}`,
  });

  return response;
};

export const CreateReservationNoteAPI = async ({ hotelId, guestId, reservationId, data }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotels/${hotelId}/guests/${guestId}/reservations/${reservationId}/notes`,
    data,
  });

  return response;
};

export const DeleteReservationNoteAPI = async ({ hotelId, guestId, reservationId, noteId }) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/hotels/${hotelId}/guests/${guestId}/reservations/${reservationId}/notes/${noteId}/hard?confirm=true`,
  });

  return response;
};

export const GetReservationSummaryAPI = async ({ hotelId, guestId, reservationId }) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/hotels/${hotelId}/guests/${guestId}/reservations/${reservationId}/ai-summary`,
  });

  return response;
};

export const GetGuestLibraryAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/guest-library/list",
    data,
  });

  return response;
};

export const GetGuestDetailsAPI = async ({ guestId, data }) => {
  return await api({
    method: "POST",
    url: `/api/v1/guest-library/${guestId}/details`,
    data,
  });
};

export const GetGuestStaysAPI = async ({ guestId, data }) => {
  return await api({
    method: "POST",
    url: `/api/v1/guest-library/${guestId}/stays`,
    data,
  });
};

export const GetGuestReservationNotesAPI = async ({ guestId, data }) => {
  return await api({
    method: "POST",
    url: `/api/v1/guest-library/${guestId}/reservation-notes`,
    data,
  });
};

export const DeleteGuestAPI = async (guestId) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/guest-deletion/guests/${guestId}?confirm=true`,
  });

  return response;
};

export const CreateGuestProfileNoteAPI = async (guestId, payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/guest-library/${guestId}/profile-notes`,
    data: payload,
  });

  return response;
};

export const UpdateGuestProfileNoteAPI = async (guestId, noteId, payload) => {
  const response = await api({
    method: "PATCH",
    url: `/api/v1/guest-library/${guestId}/profile-notes/${noteId}`,
    data: payload,
  });

  return response;
};

export const GetRemovedGuestDeletionJobsAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/guest-deletion/removed/list`,
    data: payload,
  });

  return response;
};

export const GetRemovedGuestDeletionSummaryAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/guest-deletion/removed/summary`,
    data: payload,
  });

  return response;
};

export const RetryGuestDeletionJobAPI = async (jobId) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/guest-deletion/jobs/${jobId}/retry`,
  });

  return response;
};
